import { render } from "./NoUserRoleNavbar.vue?vue&type=template&id=3be7f704"
import script from "./NoUserRoleNavbar.vue?vue&type=script&lang=js"
export * from "./NoUserRoleNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__